<div class="common-wrapper">
    <div class="main-hd-txt">
        <span>
            <h4>SECTION<span class="head-btn-style">
                <button *ngIf="!listView" (click)="goToBackTab()" class="go-back-btn-head" title="Back Tab">
                    <i class="bi bi-arrow-left-circle"></i> Back</button></span><span class="head-btn-style">
                    <button *ngIf="!listView" (click)="save($event)" class="save-btn-head" [disabled]="saveDisabled" title="Save">
                    <i class="bi bi-file-earmark-plus"></i> Save</button></span></h4>
        </span>
    </div>
    <div *ngIf="listView" class="top-btns">
        <grid [entities]="sections" [actionExclude]="['feedback','column']" [checkboxCol]="true"
            [entityColumns]="sectionColumns" [selectionField]="'Section_Id'" [addEntityIcon]="'bi bi-plus-square'"
            [addEntityCaption]="'Add'" [downloadEntityCaption]="'Download'" (downloadEntities)="onExcelExport()"
            (addEntity)="addSection($event)" (editEntity)="editSection($event)"
            (refreshEntities)="refreshSections($event)" (deleteEntity)="deleteSection($event)"
            (onPaginationChange)="onPaginationChange($event)" [serverPagination]="true" [pageSizes]="pageSizes"
            [pageSize]="defaultPageSize" [skip]="pageSkip" (onFilterChange)="onFilterChange($event)"></grid>

    </div>

    <div *ngIf="!listView">
        <div class="row sub-head">
            <div class="col-md-7 text-bold">
                {{ formCaption }}
            </div>
            <div class="col-md-5 text-end">
                <button (click)="clearSection()" class="btn-3 bt-3-ic"><span>Clear</span></button>
                <button (click)="revertChanges()" class="btn-3 bt-4-ic"><span>Revert Changes</span></button>
                <button (click)="gotoBack()" class="btn-3 bt-4-ic"><span>Go Back</span></button>
            </div>
        </div>

        <div class="col-md-12 content-area">
            <div class="row">
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'Section Name'" [formData]="entity" [maxlength]="100" [mandatory]="true"
                        [fieldName]="'SectionName'" [(ngModel)]="entity.SectionName" ngDefaultControl>
                    </textbox>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4 mb-2">
                    <dropdown [caption]="'Act'" [formData]="entity" [data]="act" [class]="'form-control'"
                        [mandatory]="false" [filterable]="true" (filterChanged)="getAllAct($event)"
                        [(ngModel)]="entity.Act_Id" [textField]="'ActName'" [valueField]="'Act_Id'"
                        [fieldName]="'Act_Id'" [selectedItem]="selectedAct" ngDefaultControl>
                    </dropdown>
                </div>
            </div>


            <div class="row">
                <div class="col-md-4 mb-2">
                    <checkbox [caption]="'Active'" [(ngModel)]="entity.IsActive"></checkbox>
                </div>
            </div>
            <!-- <div class="row">
                <div class="col-md-1">
                    <btn [label]="'Back'" (click)="goToBackTab()" [class]="'btn-next btn-11'"
                        [type]="'button'" title="Back Tab"></btn>
                </div>
                <div class="col-md-4 mb-2">
                    <btn [label]="'Save'" (click)="save($event)" [class]="'btn-1 btn-11'" [disabled]="saveDisabled"
                        [type]="'button'"></btn>
                </div>
            </div> -->
        </div>
       
    </div>
</div>
<ng-template #view let-dataItem let-rowIndex="rowIndex">
    <i class="bi bi-eye-fill" (click)="open(dataItem)"></i>
  </ng-template>
  <kendo-dialog title="Section Details" *ngIf="opened" (close)="close()" [height]="500" [width]="1000">
    <div class="col-md-12 content-area">
        <div class="row">
        <div class="col-md-4 br-table-data">
            <label for="SectionName" class="label label-1">Section Name : </label> {{details.SectionName }}
          </div>
          <div class="col-md-4 br-table-data">
            <label for="ActName" class="label label-1">Act Name : </label> {{details.ActName }}
          </div>
        </div>
    </div>
    </kendo-dialog>
<kendo-excelexport [data]="sections.data" [collapsible]="true" fileName="Section.xlsx" #excelexport>
    <kendo-excelexport-column field="SlNo" title="Sl.No." [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="SectionName" title="Section" [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="ActName" title="Act" [width]="200">
    </kendo-excelexport-column> 
    <kendo-excelexport-column field="Active" title="Active" [width]="200">
    </kendo-excelexport-column>
</kendo-excelexport>